/**
 * @generated SignedSource<<13ad3f4a5deca3aa276e7bdf8887884e>>
 * @relayHash b2fd3ca184bf3456db3ad8355caa7f12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae262129a1ecf69eb59722d77a997099b90a61cbb399dcfb949e41ca1dd95449

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraPublishIssueSearchConfigInput = {
  viewId: string;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$variables = {
  groupBy?: string | null | undefined;
  input: JiraPublishIssueSearchConfigInput;
  issueSearchInput?: JiraIssueSearchInput | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$data = {
  readonly jira_publishIssueSearchConfig: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly view: {
      readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonCollapsible">;
    } | null | undefined;
  } | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation = {
  response: SaveResetViewSettingsButtonUIPublishSettingsMutation$data;
  variables: SaveResetViewSettingsButtonUIPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueSearchInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "settings"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "staticViewInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SaveResetViewSettingsButtonCollapsible"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPublishViewConfig"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                          },
                          {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                          },
                          (v7/*: any*/),
                          {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                          }
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "groupByField",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                  },
                                  (v8/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hideDone"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                          }
                        ]
                      }
                    ],
                    "type": "JiraSpreadsheetView",
                    "abstractKey": "__isJiraSpreadsheetView"
                  },
                  {
                    "args": [
                      (v7/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "isViewConfigModified"
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              },
              (v8/*: any*/)
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ae262129a1ecf69eb59722d77a997099b90a61cbb399dcfb949e41ca1dd95449",
    "metadata": {},
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b07abd289109b7a80f615e98f5ee071d";

export default node;
